import { render, staticRenderFns } from "./modal-reset-grid.vue?vue&type=template&id=cfc3de46&scoped=true"
import script from "./modal-reset-grid.vue?vue&type=script&lang=js"
export * from "./modal-reset-grid.vue?vue&type=script&lang=js"
import style0 from "./modal-reset-grid.vue?vue&type=style&index=0&id=cfc3de46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc3de46",
  null
  
)

export default component.exports